export default __webpack_public_path__ + "static/media/5.e1976631.png";